import * as React           from "react";

import "./ad-budget-defaults-card.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {InlineAmountForm} from "../../../common/inline-amount-form/inline-amount-form";

export const AdBudgetDefaultsCard = ({branch, getAmount, setAmount}) => cs(
    consumeContext("apis"),
    ({apis}) => (
        <div className="ad-budget-defaults-card-dznuts1">
            <div className="branch-name">
                {branch.branchName || branch.branchLinkId}
            </div>
            {
                InlineAmountForm({
                    amount: getAmount(branch),
                    readOnly: false,
                    onChange: async (newAmount) => {
                        await apis.next.adBudgets.setAdBudgetDefaults([{
                            idBranch: branch.idBranch,
                            amount: newAmount,
                        }]);
                        setAmount(branch.idBranch, newAmount);
                    }
                })
            }
        </div>
    )
)